/**
 * CORE-467 — FE mirror of the backend session-end-reason taxonomy
 * (agape-backend/src/Agape.Shared/Models/EndReasons.cs).
 *
 * `WatchPartyResponse.endReason` now carries a canonical value from this closed
 * set (persisted by the backend's FinalizeEndAsync). Keep the strings in
 * lock-step with the backend and map them to user copy here rather than
 * inline-guessing why a room ended.
 */
export const END_REASONS = {
  HostEnded: 'host_ended',
  DurationElapsed: 'duration_elapsed',
  Empty: 'empty',
  MasterAbsent: 'master_absent',
  Cancelled: 'cancelled',
  Error: 'error',
  System: 'system',
} as const;

export type EndReason = typeof END_REASONS[keyof typeof END_REASONS];

const MESSAGES: Record<string, string> = {
  [END_REASONS.HostEnded]: 'Ведущий завершил сессию.',
  [END_REASONS.DurationElapsed]: 'Время сессии вышло.',
  [END_REASONS.Empty]: 'Все участники вышли.',
  [END_REASONS.MasterAbsent]: 'Ведущий не начал Live-сессию.',
  [END_REASONS.Cancelled]: 'Сессия отменена.',
  [END_REASONS.Error]: 'Сессия завершилась из-за ошибки.',
  [END_REASONS.System]: 'Сессия завершена.',
};

/** Canonical Russian copy for a session-end reason, or null if unmapped. */
export function endReasonMessage(reason: string | null | undefined): string | null {
  if (!reason) return null;
  return MESSAGES[reason] ?? null;
}
